import { Component, ChangeDetectionStrategy } from '@angular/core';
import { tap } from 'rxjs/operators';
import { BehaviorService } from '@_services/Behavior.service';

@Component({
  selector: 'app-user-firm-directory-contact-detail',
  templateUrl: './user-firm-directory-contact-detail.component.html',
  styleUrls: ['./user-firm-directory-contact-detail.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class UserFirmDirectoryContactDetailComponent {
  currentUser = JSON.parse(localStorage.getItem('currentUser'));

  userflag = true;

  $UserDetail = this._BehaviorService.FirmDirecotryData$.pipe(
    tap((userUpdatedData: any) => {
      if (
        userUpdatedData &&
        userUpdatedData.EMAIL == '' &&
        userUpdatedData.PHONE1 == '' &&
        userUpdatedData.OFFICELOCATION == '' &&
        userUpdatedData.BIOGRAPHY == ''
      ) {
        this.userflag = false;
      } else {
        this.userflag = true;
      }
    }),
  );

  constructor(public _BehaviorService: BehaviorService) {}

  /**
   * This function is used to open the toggle sidebar
   * @param key -key data value
   */
  toggleSidebarOpen(key) {
    this._BehaviorService.isFirmDirectoryContactDetailOpen$.next(false);
  }
}
